import { Component, OnInit } from '@angular/core';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { BRANDS } from 'src/app/shared/models/screen-size.enum';

@Component({
  selector: 'app-base-header',
  templateUrl: './base-header.component.html',
  styleUrls: ['./base-header.component.scss'],
})
export class BaseHeaderComponent implements OnInit {
  CONSTANTS = CONSTANTS;
  navLogo: string = CONSTANTS.KWIKSET_UNITE_LOGO;

  constructor(private stateManagementService: StateManagementService) {}

  ngOnInit(): void {
    this.setImageByBrand();
  }

  setImageByBrand(): void {
    const brandName = this.stateManagementService.getUserBrand();
    this.navLogo =
      brandName === BRANDS.KWIKSETUNITE
        ? CONSTANTS.KWIKSET_UNITE_LOGO
        : CONSTANTS.WEISER_UNITE_LOGO;
  }
}
